"use strict";

import _classCallCheck from "/vercel/workpath0/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/workpath0/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/workpath0/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/vercel/workpath0/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { isHexString } from "@ethersproject/bytes";
import { Description, defineReadOnly } from "@ethersproject/properties";
import { Logger } from "@ethersproject/logger";
import { version } from "./_version";
var logger = new Logger(version);
;
; //export type CallTransactionable = {
//    call(transaction: TransactionRequest): Promise<TransactionResponse>;
//};

export var ForkEvent = /*#__PURE__*/function (_Description) {
  _inherits(ForkEvent, _Description);

  var _super = _createSuper(ForkEvent);

  function ForkEvent() {
    _classCallCheck(this, ForkEvent);

    return _super.apply(this, arguments);
  }

  _createClass(ForkEvent, null, [{
    key: "isForkEvent",
    value: function isForkEvent(value) {
      return !!(value && value._isForkEvent);
    }
  }]);

  return ForkEvent;
}(Description);
export var BlockForkEvent = /*#__PURE__*/function (_ForkEvent) {
  _inherits(BlockForkEvent, _ForkEvent);

  var _super2 = _createSuper(BlockForkEvent);

  function BlockForkEvent(blockHash, expiry) {
    _classCallCheck(this, BlockForkEvent);

    if (!isHexString(blockHash, 32)) {
      logger.throwArgumentError("invalid blockHash", "blockHash", blockHash);
    }

    return _super2.call(this, {
      _isForkEvent: true,
      _isBlockForkEvent: true,
      expiry: expiry || 0,
      blockHash: blockHash
    });
  }

  return BlockForkEvent;
}(ForkEvent);
export var TransactionForkEvent = /*#__PURE__*/function (_ForkEvent2) {
  _inherits(TransactionForkEvent, _ForkEvent2);

  var _super3 = _createSuper(TransactionForkEvent);

  function TransactionForkEvent(hash, expiry) {
    _classCallCheck(this, TransactionForkEvent);

    if (!isHexString(hash, 32)) {
      logger.throwArgumentError("invalid transaction hash", "hash", hash);
    }

    return _super3.call(this, {
      _isForkEvent: true,
      _isTransactionForkEvent: true,
      expiry: expiry || 0,
      hash: hash
    });
  }

  return TransactionForkEvent;
}(ForkEvent);
export var TransactionOrderForkEvent = /*#__PURE__*/function (_ForkEvent3) {
  _inherits(TransactionOrderForkEvent, _ForkEvent3);

  var _super4 = _createSuper(TransactionOrderForkEvent);

  function TransactionOrderForkEvent(beforeHash, afterHash, expiry) {
    _classCallCheck(this, TransactionOrderForkEvent);

    if (!isHexString(beforeHash, 32)) {
      logger.throwArgumentError("invalid transaction hash", "beforeHash", beforeHash);
    }

    if (!isHexString(afterHash, 32)) {
      logger.throwArgumentError("invalid transaction hash", "afterHash", afterHash);
    }

    return _super4.call(this, {
      _isForkEvent: true,
      _isTransactionOrderForkEvent: true,
      expiry: expiry || 0,
      beforeHash: beforeHash,
      afterHash: afterHash
    });
  }

  return TransactionOrderForkEvent;
}(ForkEvent); ///////////////////////////////
// Exported Abstracts

export var Provider = /*#__PURE__*/function () {
  function Provider() {
    _classCallCheck(this, Provider);

    logger.checkAbstract(this instanceof Provider ? this.constructor : void 0, Provider);
    defineReadOnly(this, "_isProvider", true);
  } // Alias for "on"


  _createClass(Provider, [{
    key: "addListener",
    value: function addListener(eventName, listener) {
      return this.on(eventName, listener);
    } // Alias for "off"

  }, {
    key: "removeListener",
    value: function removeListener(eventName, listener) {
      return this.off(eventName, listener);
    }
  }], [{
    key: "isProvider",
    value: function isProvider(value) {
      return !!(value && value._isProvider);
    }
  }]);

  return Provider;
}();